import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiInsertMediaComponent } from './fi-insert-media.component';
import { FiFileUpload2Service } from '@fi-shared/fi-insert-media/fi-file-upload2.service';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiBtnUploadFileModule } from '@fi-shared/fi-insert-media/btn-upload-file/btn-upload-file.module';
import { FiInsertMediaDialogComponent } from './fi-insert-media-dialog.component';
import { FiInsertMedia2Service } from '@fi-shared/fi-insert-media/fi-insert-media2.service';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { FiInsertMediaDetailsComponent } from './fi-insert-media-details/fi-insert-media-details.component';
import { MatSortModule } from '@angular/material/sort';
import { FiWrapperTableModule } from '@fi-shared/fi-wrapper-table/fi-wrapper-table.module';
import { MatTableModule } from '@angular/material/table';
import { FiFormatDateModule } from '@fi-shared/fi-format-date/fi-format-date.module';
import { MatInputModule } from '@angular/material/input';
import { FiOptionsModule } from '@fi-shared/fi-options/fi-options.module';
import { FiWhenScrolledModule } from '@fi-shared/fi-directives/when-scrolled/when-scrolled.module';
import { FiLocalSearch2Module } from '@fi-shared/fi-local-search2/fi-local-search2.module';
import { FiDndOverlayComponent } from './fi-dnd-overlay/fi-dnd-overlay.component';
import { FiInsertMediaUploadHelperComponent } from '@fi-shared/fi-insert-media/fi-insert-media-upload-helper/fi-insert-media-upload-helper.component';
import { FiItemsListModule } from '@fi-shared/fi-items-list/fi-items-list.module';
import { FiInsertMediaDetailsGridViewComponent } from './fi-insert-media-details/fi-insert-media-details-grid-view/fi-insert-media-details-grid-view.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FiInsertMediaDetailsFilterComponent } from './fi-insert-media-details/fi-insert-media-details-filter/fi-insert-media-details-filter.component';
import { MatDividerModule } from '@angular/material/divider';
import { FiInsertMediaDetailsOldUploadsComponent } from './fi-insert-media-details/fi-insert-media-details-old-uploads/fi-insert-media-details-old-uploads.component';
import { FiLoadingModule } from '@fi-shared/fi-loading/fi-loading.module';
import { FiExifHelperService } from '@fi-shared/fi-insert-media/fi-exif-helper.service';
import { FiTooltipModule } from '@fi-shared/fi-tooltip/fi-tooltip.module';
import { FiFileUploadProgressComponent } from '@fi-shared/fi-insert-media/fi-file-upload-progress/fi-file-upload-progress.component';
import { FiFileUploadPlaceholderComponent } from '@fi-shared/fi-insert-media/fi-file-upload-placeholder/fi-file-upload-placeholder.component';
import { FiFileUploadComponent } from '@fi-shared/fi-insert-media/fi-file-upload/fi-file-upload.component';
import { FiFileUploadHelperService } from '@fi-shared/fi-insert-media/fi-file-upload-helper.service';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatButtonModule,
        MatMenuModule,
        MatIconModule,
        MatProgressBarModule,
        MatSortModule,
        MatTableModule,
        MatInputModule,
        FiAppTextSharedModule,
        FiBtnUploadFileModule,
        FiWrapperTableModule,
        FiFormatDateModule,
        FiOptionsModule,
        FiWhenScrolledModule,
        FiLocalSearch2Module,
        FiItemsListModule,
        MatCheckboxModule,
        MatDividerModule,
        FiLoadingModule,
        FiTooltipModule,
    ],
    declarations: [
        FiInsertMediaComponent,
        FiInsertMediaDialogComponent,
        FiInsertMediaDetailsComponent,
        FiDndOverlayComponent,
        FiInsertMediaUploadHelperComponent,
        FiInsertMediaDetailsGridViewComponent,
        FiInsertMediaDetailsFilterComponent,
        // FiInsertMediaDetailsNewUploadsComponent,
        FiInsertMediaDetailsOldUploadsComponent,
        FiFileUploadComponent,
        FiFileUploadProgressComponent,
        FiFileUploadPlaceholderComponent,
    ],
    providers: [FiFileUpload2Service, FiInsertMedia2Service, FiFileUploadHelperService, FiExifHelperService],
    exports: [
        FiInsertMediaComponent,
        FiInsertMediaUploadHelperComponent,
        FiDndOverlayComponent,
        FiFileUploadComponent,
        FiFileUploadProgressComponent,
        FiFileUploadPlaceholderComponent,
    ],
})
export class FiInsertMediaModule {}
